import { defineStore } from 'pinia'

// initial state
const state = () => ({
  order: 'date',
  view: null,
  views: [],
})

// functionName: (state, getters, rootState) => {}
const getters = {}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  toggleOrder() {
    if (this.order === 'date') {
      this.order = 'name'
    } else {
      this.order = 'date'
    }
  }
}

export default defineStore({
  id: 'bcHome',
  state,
  getters,
  actions
})
